// Service showcase — dance/stage, casino, hotel & nightlife imagery.
// (previously 'girls' — repurposed as service catalog for Google Ads compliance)
export const girls = [
  // STAGE / DANCE / SHOW — 6 items (nightclub, cabaret, stage, DJ ambiance)
  {
    id: "cabaret-show",
    name: "Cabaret & Stage Show",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "Sahne + Lazer + Işık",
    languages_en: "Stage + Laser + Light",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1400&q=85",
      "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=1400&q=85",
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1400&q=85",
      "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1400&q=85",
      "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=1400&q=85",
    ],
    bio_tr: "Girne'nin lisanslı sahne kulüplerinde kabare stili şov geceleri. Koreografili sahne performansları, canlı sahne müziği, VIP ayrılmış alan ve şampanya töreni pakete dahil. Bekarlığa veda ve doğum günü kutlamaları için imza deneyimimiz.",
    bio_en: "Cabaret-style show nights at Kyrenia's licensed stage clubs. Choreographed stage performances, live stage music, reserved VIP zone and a champagne ritual included. Our signature experience for bachelor and birthday celebrations.",
  },
  {
    id: "aerial-performance",
    name: "Aerial Silk & Pole Performance",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "Havai gösteri + Işık",
    languages_en: "Aerial show + Lights",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1400&q=85",
      "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=1400&q=85",
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1400&q=85",
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1400&q=85",
      "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=1400&q=85",
    ],
    bio_tr: "Aerial silk ve profesyonel sahne dansı gösterileri — Cirque du Soleil estetiğinde koreografili sanatsal performanslar. Girne'nin lisanslı sahne kulüplerinde, VIP masa erişimi ve şampanya servisi ile birlikte sunulur. Misafirlere unutulmaz bir gece.",
    bio_en: "Aerial silk and professional stage dance shows — choreographed artistic performances in a Cirque du Soleil aesthetic. Delivered at Kyrenia's licensed stage clubs together with VIP table access and champagne service. An unforgettable night for guests.",
  },
  {
    id: "live-dj-set",
    name: "Live DJ Night",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "House + Techno + Latin",
    languages_en: "House + Techno + Latin",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1400&q=85",
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1400&q=85",
      "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=1400&q=85",
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1400&q=85",
      "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=1400&q=85",
    ],
    bio_tr: "Girne'nin en popüler gece kulüplerinde canlı DJ setleri — house, techno, latin ve Türkçe pop. VIP masa, öncelikli giriş ve DJ ile özel istek koordinasyonu. Bottle service ve şampanya opsiyonu ile.",
    bio_en: "Live DJ sets at Kyrenia's most popular nightclubs — house, techno, latin and Turkish pop. VIP table, priority entry and dedicated DJ-request coordination. With bottle service and champagne options.",
  },
  {
    id: "vip-bottle-service",
    name: "VIP Bottle & Champagne",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "Şampanya + Bottle service",
    languages_en: "Champagne + Bottle service",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1400&q=85",
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1400&q=85",
      "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1400&q=85",
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1400&q=85",
    ],
    bio_tr: "Girne'nin lüks gece kulüplerinde VIP bottle service — Dom Pérignon, Cristal, Moët Rose ve Grey Goose bottle koordinasyonu. Ayrılmış VIP masa, özel garson ve şampanya töreni ile.",
    bio_en: "VIP bottle service at Kyrenia's luxury nightclubs — Dom Pérignon, Cristal, Moët Rose and Grey Goose bottle coordination. Reserved VIP table, dedicated waiter and a signature champagne ritual.",
  },
  {
    id: "laser-stage-experience",
    name: "Laser & Stage Experience",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "Lazer + Sis + Sahne",
    languages_en: "Laser + Fog + Stage",
    tags: ["new", "featured"],
    cover: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1400&q=85",
      "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1400&q=85",
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1400&q=85",
      "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=1400&q=85",
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1400&q=85",
    ],
    bio_tr: "Lazer, duman ve büyük sahne ışıkları eşliğinde konser hissi veren gösteriler. Genç grup ve doğum günü kutlamaları için ideal — 500+ kişilik dans pisti ve VIP alanlar.",
    bio_en: "Concert-like shows with laser, smoke and grand stage lighting. Ideal for younger groups and birthday celebrations — 500+ capacity dance floor and VIP zones.",
  },
  {
    id: "live-vocals-night",
    name: "Live Vocals & Piano",
    nationality_tr: "Sahne / Show",
    nationality_en: "Stage / Show",
    languages_tr: "Canlı vokal + Piyano",
    languages_en: "Live vocals + Piano",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1574391884720-bbc3740c59d1?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1574391884720-bbc3740c59d1?w=1400&q=85",
      "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1400&q=85",
      "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1400&q=85",
      "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=1400&q=85",
    ],
    bio_tr: "Piyano eşliğinde canlı vokal geceleri — jazz, motown, latin ve Türkçe klasikler. Sohbet edilebilir dinlence tipi bir gece; şarap seçkisi ve peynir tabakları ile birlikte.",
    bio_en: "Live vocals with piano — jazz, motown, latin and Turkish classics. A conversation-friendly listening evening; paired with a curated wine list and cheese boards.",
  },

  // OTEL — 6 items
  {
    id: "cratos-suite",
    name: "Cratos Premium Suite",
    nationality_tr: "5★ Otel",
    nationality_en: "5★ Hotel",
    languages_tr: "Casino + Deniz manzarası",
    languages_en: "Casino + Sea view",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=1200&q=80",
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=1200&q=80",
    ],
    bio_tr: "Cratos Premium Hotel Suite — Girne'nin en büyük casino kompleksinde deniz manzaralı, geniş süit. Executive kat erişimi, VIP karşılama ve oda upgrade koordinasyonu paketimizle dahildir.",
    bio_en: "Cratos Premium Hotel Suite — a spacious sea-view suite at Kyrenia's largest casino complex. Executive floor access, VIP welcome and room-upgrade coordination included in our package.",
  },
  {
    id: "merit-seaview",
    name: "Merit Crystal Cove Sea Suite",
    nationality_tr: "5★ Otel",
    nationality_en: "5★ Hotel",
    languages_tr: "Deniz manzaralı süit",
    languages_en: "Sea-view suite",
    tags: ["vip"],
    cover: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=1200&q=80",
      "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?w=1200&q=80",
    ],
    bio_tr: "Merit Crystal Cove — Girne'nin sahil kenarı en romantik lüks otel süiti. Deniz manzarası, jakuzi ve balkon. Bal ayı ve özel kutlamalar için tercih.",
    bio_en: "Merit Crystal Cove — Kyrenia's most romantic seafront luxury suite. Sea view, jacuzzi and balcony. Preferred for honeymoons and special celebrations.",
  },
  {
    id: "acapulco-beach",
    name: "Acapulco Beach Villa",
    nationality_tr: "Villa",
    nationality_en: "Villa",
    languages_tr: "Özel havuz + Sahil",
    languages_en: "Private pool + Beach",
    tags: ["vip", "new"],
    cover: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=1200&q=80",
    ],
    bio_tr: "Acapulco Resort'un özel plaj villası — kendi havuzu, sahil erişimi ve butler servisi. Grup tatilleri ve özel etkinlikler için ideal.",
    bio_en: "Acapulco Resort's private beach villa — its own pool, beach access and butler service. Ideal for group holidays and private events.",
  },
  {
    id: "concorde-luxe",
    name: "Concorde Luxury Suite",
    nationality_tr: "5★ Otel",
    nationality_en: "5★ Hotel",
    languages_tr: "Kral Dairesi",
    languages_en: "Presidential Suite",
    tags: ["vip"],
    cover: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80",
    ],
    bio_tr: "Concorde Luxury Resort kral dairesi — geniş oturma salonu, ayrı yatak odası, deniz manzaralı balkon. Uzun süreli konaklamalar için lüks alternatif.",
    bio_en: "Concorde Luxury Resort presidential suite — a spacious living lounge, separate bedroom and sea-view balcony. A luxury alternative for extended stays.",
  },
  {
    id: "lords-palace",
    name: "Lord's Palace Suite",
    nationality_tr: "5★ Otel",
    nationality_en: "5★ Hotel",
    languages_tr: "Şehir merkezi",
    languages_en: "City centre",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=1200&q=80",
    ],
    bio_tr: "Lord's Palace Hotel — Girne şehir merkezinde restoranlar ve sahile yürüme mesafesinde modern süit. İş seyahatleri için pratik seçim.",
    bio_en: "Lord's Palace Hotel — a modern suite in central Kyrenia, walking distance to restaurants and the seafront. A practical pick for business trips.",
  },
  {
    id: "kaya-artemis-vip",
    name: "Kaya Artemis Resort VIP",
    nationality_tr: "Resort",
    nationality_en: "Resort",
    languages_tr: "Aile & tema resort",
    languages_en: "Family & themed resort",
    tags: ["new"],
    cover: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200&q=80",
    ],
    bio_tr: "Kaya Artemis Resort — Karpaz yakınlarında büyük tema resort. Çoklu havuzlar, tema restoranlar ve aile-dostu ortam.",
    bio_en: "Kaya Artemis Resort — a large themed resort near Karpaz. Multiple pools, themed restaurants and a family-friendly atmosphere.",
  },

  // CASINO — 6 items
  {
    id: "cratos-blackjack",
    name: "Cratos Blackjack VIP",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "Yüksek limit + Şef koord.",
    languages_en: "High limit + Chef coord.",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=1200&q=80",
      "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=1200&q=80",
      "https://images.unsplash.com/photo-1541278107931-e006523892df?w=1200&q=80",
    ],
    bio_tr: "Cratos Casino'nun yüksek limitli blackjack masaları için VIP koordinasyon. Yüksek limitli oyunculara özel salon erişimi ve masa rezervasyonu.",
    bio_en: "VIP coordination for the high-limit blackjack tables at Cratos Casino. Private salon access and table reservations for high-limit players.",
  },
  {
    id: "merit-roulette",
    name: "Merit Roulette Salon",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "Rulet + Bar",
    languages_en: "Roulette + Bar",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=1200&q=80",
      "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=1200&q=80",
    ],
    bio_tr: "Merit Crystal Cove Casino'nun rulet salonu — Amerikan ve Avrupa ruleti. Çok dilli krupiye ve VIP bar servisi.",
    bio_en: "Merit Crystal Cove Casino roulette hall — American and European roulette. Multilingual dealers and VIP bar service.",
  },
  {
    id: "poker-tournament",
    name: "International Poker Turnuvası",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "NLH + PLO Turnuva",
    languages_en: "NLH + PLO Tournament",
    tags: ["vip"],
    cover: "https://images.unsplash.com/photo-1541278107931-e006523892df?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1541278107931-e006523892df?w=1200&q=80",
    ],
    bio_tr: "Cratos ve Merit'te düzenlenen uluslararası poker turnuvaları için koordinasyon: kayıt, rebuy planlaması ve konaklama entegrasyonu.",
    bio_en: "Coordination for international poker tournaments hosted at Cratos and Merit: registration, rebuy planning and lodging integration.",
  },
  {
    id: "high-limit-baccarat",
    name: "High-Limit Baccarat",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "Özel oda + Krupiye",
    languages_en: "Private room + Dealer",
    tags: ["vip"],
    cover: "https://images.unsplash.com/photo-1541278107931-e006523892df?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1541278107931-e006523892df?w=1200&q=80",
    ],
    bio_tr: "Yüksek limitli baccarat masaları için özel oda ve krupiye koordinasyonu. Diskret misafir kabul ve tercihe göre sınırsız bahis.",
    bio_en: "Private room and dealer coordination for high-limit baccarat tables. Discreet guest reception and unlimited bet options as requested.",
  },
  {
    id: "casino-vip-lounge",
    name: "Casino VIP Lounge",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "Şampanya + Kanepe",
    languages_en: "Champagne + Lounge",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=1200&q=80",
      "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1200&q=80",
    ],
    bio_tr: "Casino VIP salonuna erişim: ayrı bar, konforlu kanepeler ve özel gece atıştırmalıkları. Sadece davetli.",
    bio_en: "Access to a casino VIP lounge: private bar, comfortable sofas and exclusive late-night bites. Invitation only.",
  },
  {
    id: "casino-slots-tour",
    name: "Slot Salonu Ziyaret",
    nationality_tr: "Casino",
    nationality_en: "Casino",
    languages_tr: "Rehber + Bonus",
    languages_en: "Guide + Bonus",
    tags: ["new"],
    cover: "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=1200&q=80",
    ],
    bio_tr: "Casino slot salonu ziyaretinde rehberli tur — en popüler makineler, jackpot geçmişleri ve bonus kartı koordinasyonu.",
    bio_en: "A guided tour of the casino slot hall — the most popular machines, jackpot history and bonus-card coordination.",
  },

  // DANS / GECE HAYATI — 6 items
  {
    id: "beach-club-day",
    name: "Beach Club Gündüz",
    nationality_tr: "Dans / Gece",
    nationality_en: "Dance / Nightlife",
    languages_tr: "Havuz partisi + DJ",
    languages_en: "Pool party + DJ",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1540946485063-a40da27545f8?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1540946485063-a40da27545f8?w=1200&q=80",
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1200&q=80",
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&q=80",
    ],
    bio_tr: "Acapulco ve diğer beach club'larda gündüz partileri: havuz kenarı DJ setleri, cocktail servisi ve VIP masa rezervasyonu.",
    bio_en: "Daytime parties at Acapulco and other beach clubs: poolside DJ sets, cocktail service and VIP table reservations.",
  },
  {
    id: "vip-nightclub-table",
    name: "VIP Kulüp Masası",
    nationality_tr: "Dans / Gece",
    nationality_en: "Dance / Nightlife",
    languages_tr: "Şampanya + VIP giriş",
    languages_en: "Champagne + VIP entry",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1200&q=80",
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&q=80",
      "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1200&q=80",
    ],
    bio_tr: "Girne'nin en populer gece kulüplerinde VIP masa: Şampanya servisi, öncelikli giriş ve bottle service koordinasyonu.",
    bio_en: "VIP table at Kyrenia's most popular nightclubs: champagne service, priority entry and bottle-service coordination.",
  },
  {
    id: "dance-floor-experience",
    name: "Dans Pisti Deneyimi",
    nationality_tr: "Dans / Gece",
    nationality_en: "Dance / Nightlife",
    languages_tr: "Live DJ + Lazer show",
    languages_en: "Live DJ + Laser show",
    tags: ["featured"],
    cover: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1200&q=80",
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&q=80",
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&q=80",
    ],
    bio_tr: "Gece kulüplerinde canlı DJ setleri, lazer show ve dans pisti deneyimi. Grup rezervasyonlarına özel indirim.",
    bio_en: "Live DJ sets, laser shows and dance-floor experience at nightclubs. Special discount for group reservations.",
  },
  {
    id: "cocktail-bar",
    name: "Rooftop Cocktail Bar",
    nationality_tr: "Bar / Terrace",
    nationality_en: "Bar / Terrace",
    languages_tr: "Şehir manzarası + Bar",
    languages_en: "City view + Bar",
    tags: ["new"],
    cover: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1200&q=80",
    ],
    bio_tr: "Girne'nin rooftop cocktail bar'larında şehir ve deniz manzaralı akşam. İmza kokteyller ve tapa tarzı yemekler.",
    bio_en: "An evening at Kyrenia's rooftop cocktail bars with city and sea views. Signature cocktails and tapas-style bites.",
  },
  {
    id: "yacht-party-sunset",
    name: "Yat Gün Batımı Turu",
    nationality_tr: "Yat / Deniz",
    nationality_en: "Yacht / Sea",
    languages_tr: "Kaptan + Şampanya",
    languages_en: "Captain + Champagne",
    tags: ["vip", "featured"],
    cover: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1200&q=80",
      "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1200&q=80",
    ],
    bio_tr: "Girne Yat Limanı'ndan kalkışlı lüks yatlarla gün batımı turu. Şampanya, catering ve kaptan koordinasyonu dahil.",
    bio_en: "Sunset cruises on luxury yachts departing from Kyrenia Marina. Champagne, catering and captain coordination included.",
  },
  {
    id: "private-yacht-full",
    name: "Özel Yat Tam Gün",
    nationality_tr: "Yat / Deniz",
    nationality_en: "Yacht / Sea",
    languages_tr: "Karpaz turu + Şef",
    languages_en: "Karpaz tour + Chef",
    tags: ["vip"],
    cover: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1200&q=80",
    ],
    bio_tr: "Tam gün özel yat kiralama — Karpaz kıyılarına programlı rota, şef eşliğinde catering ve dalış/snorkel opsiyonları.",
    bio_en: "Full-day private yacht charter — a programmed route along the Karpaz coast, chef-catered menus and diving/snorkelling options.",
  },
];
